<template>
  <div class="indexHR">
    <img class="banner" src="@/assets/imgs/index/indexHR-banner.png" alt="" />
    <div class="indexHRWrap">
      <h3>HR权益</h3>
      <div class="menuWrap">
        <div class="menuItem" v-for="item in menuArr" :key="item.url">
          <img class="icon img-active" :src="require(`@/assets/imgs/index/img-${item.url}-active.png`)" alt="" />
          <img class="icon img-default" :src="require(`@/assets/imgs/index/img-${item.url}.png`)" alt="" />
          <p class="label" @click="handleLink(item)">
            {{ item.functionName }}
            <img class="toRight" src="@/assets/imgs/index/icon-toRight.png" alt="" />
          </p>
        </div>
      </div>
    </div>
    <DtCopyright bg="rgba(120, 120, 124, 1)" color="#FFFFFF" width="1200px" />
  </div>
</template>

<script>
import DtCopyright from '@/components/layouts/DtCopyright';

export default {
  components: { DtCopyright },
  data() {
    return {
      menuArr: [],
    };
  },
  mounted() {
    this.menuArr = this.$store.state.user.user.permission.filter(item => !item.appCode);
  },
  methods: {
    handleLink(item) {
      this.$sa('welfareHRIndexElementClick',{
        '$element_name':item.functionName
      });
      this.$router.push({ name: item.url });
    },
  },
};
</script>

<style lang="less" scoped>
.indexHR {
  background: #fff;
  .banner {
    display: block;
    width: 100%;
  }
  .indexHRWrap {
    position: relative;
    box-sizing: border-box;
    width: @contentWidth;
    margin: -35px auto 90px;
    padding: 35px 60px 60px;
    color: #333;
    border: 1px solid #dcdce1;
    background-color: #fff;
    background-image: url('~@/assets/imgs/index/indexHR-bg.png');
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: contain;
    box-shadow: 0 0 18px 0 rgba(207, 207, 207, 0.5);
    h3 {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      font-size: 28px;
      font-weight: 500;
      &::before {
        content: '';
        width: 5px;
        height: 25px;
        margin-right: 8px;
        background: var(--primary);
      }
    }
  }
  .menuWrap {
    display: flex;
    flex-wrap: wrap;
  }
  .menuItem {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 330px;
    height: 206px;
    margin-right: 44px;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 500;
    border-radius: 6px;
    background-color: #f6f6f8;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      border-radius: 6px;
      background-image: linear-gradient(180deg, #e27c00 0%, #eaa110 100%);
      transition: 0.5s;
    }
    &:hover {
      &::before {
        opacity: 1;
        box-shadow: 0 9px 16px -8px #e27c00;
      }
      .img-default {
        display: block;
      }
      .img-active {
        display: none;
      }
      .label {
        color: var(--primary);
        background-color: #fff;
      }
      .toRight {
        opacity: 1;
      }
    }
  }
  .icon {
    position: relative;
    z-index: 2;
    &.img-default {
      display: none;
    }
    &.img-active {
      display: block;
    }
  }
  .label {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 25px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      color: rgba(226, 124, 0, 0.5);
      .toRight {
        width: 18px;
        opacity: 0.75;
      }
    }
    .toRight {
      width: 0;
      margin-left: 4px;
      transition: 0.3s;
    }
  }
}

</style>
